<div class="color-palette-selector-container">
  <mode-color-palette-selector
    class="palette-selector"
    [selectedColorPalette]="selectedColorPalette"
    [allColorPalettes]="allColorPalettes"
    buttonHeight="compact"
    (paletteChanged)="onPaletteChanged($event)">
  </mode-color-palette-selector>

  <span class="swatch-container" *ngIf="selectedColorPalette">
    <button
      *ngFor="let color of selectedColorPalette.value | split"
      class="swatch"
      (click)="onSwatchClick(color)"
      [class.is-selected]="isSelected(color)"
      attr.data-test="swatch-{{ selectedColorPalette.token }}-{{ color.trim() }}"
      [style.background]="color"
    ></button>
  </span>
</div>
